<div class="profile-card" [class.compact]="hideContactInfo">
  <!-- Top half with blue background -->
  <div class="top-half">
    <div class="avatar-section">
      <!-- Show real photo if available -->
      <img
        *ngIf="user.photoURL"
        referrerpolicy="no-referrer"
        [src]="user.photoURL"
        alt="User Avatar"
        width="70"
        height="70"
      />
      <!-- Show mat-icon as fallback if no photo -->
      <mat-icon *ngIf="!user.photoURL" class="avatar-icon">account_circle</mat-icon>
    </div>
    <div class="name-title-section">
      <span class="body-text-white">{{ user.name || 'N/A' }}</span>
      <span class="body-text-white !text-[12px]">{{ user.title || 'N/A' }}</span>
    </div>
  </div>
  <!-- Bottom half with white background (hidden when hideContactInfo is true) -->
  <div class="bottom-half">
    <div class="avatar-spacer"></div>
    <div class="contact-section" *ngIf="!hideContactInfo">
      <span class="body-text-xs-dark">{{ user.email || 'N/A' }}</span>
      <span class="body-text-xs-dark" *ngIf="user.phone">{{ user.phone }}</span>
    </div>
  </div>
</div>
